<template>
  <div class="cross-analysis">
    <el-row class="header-row">
      <span class="sample-title">{{removeLables(title)}}(ID: {{surveyId}})</span>
      <el-button type="text" v-if="role!=2" class="pull-right" @click="handleExport">导出分析结果</el-button>
      <el-button type="text" v-else class="pull-right" :disabled="true" @click="handleExport">导出分析结果</el-button>
    </el-row>
    <el-row class="main-container">
      <el-row class="define-part">
        <el-col :span="12" class="col-define pull-left">
          <p class="define-title">
            定义列
            <span>（一般为样本属性，如性别，年龄等）</span>
          </p>
          <div v-for="i in rowIdxArr.length" :key="i">
            <el-select v-model="rowIdxArr[i - 1]" @change="(idx) => {handleSelectRow(idx, i - 1)}">
              <el-option
                v-for="(ques, k) in allQues"
                :key="k"
                :disabled="ques.type !== 'radio' && ques.type !== 'checkbox' && ques.type !== 'select' || rowIdxArr.indexOf(ques.index) > -1"
                :label="(ques.index + 1) + '.' + removeLables(ques.title)"
                :value="ques.index"
              ></el-option>
            </el-select>
            <el-button type="text" @click="handleDelRow(i - 1)">删除</el-button>
          </div>
          <el-button type="text" class="add-select-btn" @click="handleAddRow">添加+</el-button>
        </el-col>
        <el-col :span="12" class="row-define pull-left">
          <p class="define-title">
            定义行
            <span>（一般为需要分析的题目，如爱好，意愿等）</span>
          </p>
          <div v-for="i in colIdxArr.length" :key="i">
            <el-select v-model="colIdxArr[i - 1]" @change="(idx) => {handleSelectCol(idx, i - 1)}">
              <el-option
                v-for="(ques, k) in allQues"
                :key="k"
                :disabled="ques.type !== 'radio' && ques.type !== 'checkbox' && ques.type !== 'select' || colIdxArr.indexOf(ques.index) > -1"
                :label="(ques.index + 1) + '.' + removeLables(ques.title)"
                :value="ques.index"
              ></el-option>
            </el-select>
            <el-button type="text" @click="handleDelCol(i - 1)">删除</el-button>
          </div>
          <el-button type="text" class="add-select-btn" @click="handleAddCol">添加+</el-button>
        </el-col>
      </el-row>
      <el-button type="primary" class="cross-btn" @click="handleCrossAnalysis">交叉分析</el-button>
      <div class="cross-content" v-if="startAnalysis">
        <div class="cross-column">
          <div class="cross-corner"></div>
          <div class="col-item" v-for="(ques, i) in colArr" :key="i">
            <p class="col-title" :title="removeLables(ques.title)">{{removeLables(ques.title)}}</p>
            <ul class="col-options">
              <li v-for="(opt, idx) in ques.options" :title="opt.text" :key="idx">{{ opt.text }}</li>
            </ul>
          </div>
        </div>
        <el-table v-loading="loadingData" class="cross-table" :data="tableData" style="width: 100%">
          <el-table-column
            prop="title"
            show-overflow-tooltip
            v-for="(ques, i) in rowArr"
            :key="i"
            :label="removeLables(ques.title)"
            align="center"
          >
            <el-table-column
              align="center"
              v-for="(opt, idx) in ques.options"
              :key="idx"
              show-overflow-tooltip
              :label="opt.text"
            >
              <template slot-scope="scope">{{ scope.row[calcIdx(i) + idx] }}</template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>
<script>
import { messageMixin } from "../utils/mixins.js";
import axios from "axios";
import qs from "qs";
import { DOMAIN } from "../utils/api";
import http from '../utils/http'
import { mapGetters, mapMutations, mapActions } from "vuex";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

export default {
  name: "crossAnalysis",
  mixins: [messageMixin],
  mounted() {
    let { id, title = "" } = this.$route.query;
    this.surveyId = id;
    this.title = title;
    this.getSurvey();
  },
  data() {
    return {
      interface: {
        getSurvey: `/survey/get`,
        analysis: `/analysis/cross`,
        exportResult: `${DOMAIN}/analysis/exportCross`
      },
      surveyId: null,
      title: "",
      survey: {
        pages: []
      },
      tableData: [],
      colArr: [],
      colIdxArr: [],
      rowArr: [],
      rowIdxArr: [],
      popVisible: false,
      startAnalysis: false,
      loadingData: false
    };
  },
  computed: {
    allQues() {
      let _quesArr = [];
      this.survey.pages.forEach(page => {
        page.questions.forEach(ques => {
          if (ques.type !== "description") _quesArr.push(ques);
        });
      });
      return _quesArr;
    },
    colJson() {
      let _arr = [];
      this.colArr.forEach(val => {
        let obj = {
          questionId: val.id,
          optionId: []
        };
        val.options.forEach(opt => {
          obj.optionId.push(opt.id);
        });
        _arr.push(obj);
      });
      return _arr;
    },
    rowJson() {
      let _arr = [];
      this.rowArr.forEach(val => {
        let obj = {
          questionId: val.id,
          optionId: []
        };
        val.options.forEach(opt => {
          obj.optionId.push(opt.id);
        });
        _arr.push(obj);
      });
      return _arr;
    },
    colText() {
      let _arr = [];
      this.colArr.forEach(val => {
        let obj = {
          questionText: this.removeLables(val.title),
          optionText: []
        };
        val.options.forEach(opt => {
          obj.optionText.push(opt.text);
        });
        _arr.push(obj);
      });
      return _arr;
    },
    rowText() {
      let _arr = [];
      this.rowArr.forEach(val => {
        let obj = {
          questionText: this.removeLables(val.title),
          optionText: []
        };
        val.options.forEach(opt => {
          obj.optionText.push(opt.text);
        });
        _arr.push(obj);
      });
      return _arr;
    },
    ...mapGetters(["role"])
  },
  methods: {
    getSurvey() {
      http
        .get(this.interface.getSurvey, {
surveyId: this.surveyId
        })
        .then(response => {
          let { code, data, message } = response;
          if (code === 1) {
            this.survey = data;
          } else {
            this.showError(message);
          }
        })
        .catch(error => {
          this.showError(error);
        });
    },
    getResult() {
      this.loadingData = true;
      http
        .post(
          this.interface.analysis,
         {
            surveyId: this.surveyId,
            row: JSON.stringify(this.rowJson),
            col: JSON.stringify(this.colJson)
          }
        )
        .then(response => {
          this.startAnalysis = true;
          this.loadingData = false;
          let { code, data, message } = response;
          if (code === 1) {
            this.tableData = data;
          } else {
            this.showError(message);
          }
        })
        .catch(error => {
          this.showError(error);
        });
    },
    removeLables(html) {
      return html.replace(/<\/?.+?>/g, "");
    },
    handleAddCol() {
      this.colIdxArr.push(null);
    },
    handleAddRow() {
      this.rowIdxArr.push(null);
    },
    handleSelectCol(idx, colIdx) {
      this.colIdxArr.splice(colIdx, 1, idx);
    },
    handleSelectRow(idx, rowIdx) {
      this.rowIdxArr.splice(rowIdx, 1, idx);
    },
    handleDelCol(i) {
      this.colIdxArr.splice(i, 1);
    },
    handleDelRow(i) {
      this.rowIdxArr.splice(i, 1);
    },
    handleCrossAnalysis() {
      if (this.colIdxArr.length === 0) {
        this.showError("请先定义列再点击分析按钮");
        return;
      }
      if (this.rowIdxArr.length === 0) {
        this.showError("请先定义行再点击分析按钮");
        return;
      }
      if (
        this.colIdxArr.indexOf(null) > -1 ||
        this.rowIdxArr.indexOf(null) > -1
      ) {
        this.showError("请配置完整再点击分析按钮");
        return;
      }
      this.colArr = this.colIdxArr.map(val => {
        return this.allQues[val];
      });
      this.rowArr = this.rowIdxArr.map(val => {
        return this.allQues[val];
      });
      this.getResult();
    },
    handleExport() {
      axios
        .post(
          this.interface.exportResult,
          qs.stringify({
            // 用axios发送post请求
            surveyId: this.surveyId,
            row: JSON.stringify(this.rowJson),
            col: JSON.stringify(this.colJson),
            rowText: JSON.stringify(this.rowText),
            colText: JSON.stringify(this.colText)
          }),
          {
            responseType: "blob" // 表明返回服务器返回的数据类型
          }
        )
        .then(res => {
          // 处理返回的文件流
          const content = res.data;
          const blob = new Blob([content]);
          const fileName = this.title + "交叉分析结果.csv";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        });
    },
    calcIdx(idx) {
      let sum = 0;
      for (let i = 0; i < this.rowArr.length; i++) {
        if (i === idx) {
          return sum;
        }
        sum += this.rowArr[i].options.length;
      }
    }
  }
};
</script>
<style lang="scss">
.cross-analysis {
  padding: 25px;
  height: 100%;
  background-color: #fff;
  color: #999;
  border: 1px solid #e7e7e7;
  overflow-y: auto;
  .sample-title {
    color: #333;
  }
  .header-row {
    .page-dataType {
      width: 130px;
    }
    .dataTypeShow {
      width: 100px;
    }
  }
  .main-container {
    height: calc(100% - 60px);
  }
  .side-bar {
    width: 220px;
    overflow-y: auto;
    height: 100%;
    background-color: #eee;
    padding: 15px;
    border: 1px solid #ccc;
    float: left;
    li {
      height: 34px;
      line-height: 34px;
      color: #666;
      cursor: pointer;
      .side-bar-title {
        width: calc(100% - 25px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
      }
      span {
        float: left;
        margin-left: 5px;
        .el-button--text {
          padding: 0;
        }
      }
    }
  }
  .el-table thead.is-group th,
  .el-table thead.is-group th {
    background-color: #eee;
  }
  .el-table--border th,
  .el-table--border td,
  .el-table--group,
  .el-table--border {
    border-color: #ccc;
  }
  .el-table--group::after,
  .el-table--border::after,
  .el-table::before {
    background-color: #ccc;
  }
  .el-table th,
  .el-table td {
    padding: 0;
  }
  .el-table__empty-block {
    min-height: 25px;
  }
  .el-table th > .cell {
    white-space: nowrap;
    font-weight: normal;
  }
  .cross-column {
    width: 220px;
    float: left;
    border: 1px solid #ccc;
    border-right: 0;
  }
  .cross-content {
    width: 100%;
    margin-bottom: 30px;
    overflow: hidden;
    padding-top: 40px;
    border-top: 1px solid #eee;
  }
  .cross-table {
    width: calc(100% - 220px) !important;
    float: left;
  }
  .col-item {
    overflow: hidden;
    border-right: 0;
    background-color: #eee;
    border-bottom: 1px solid #ccc;
    &:last-child {
      border-bottom: 0;
    }
  }
  .col-title {
    width: 40%;
    float: left;
    overflow: hidden;
    text-overflow: ellipsis;
    // white-space: nowrap;
    text-align: center;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .col-options {
    float: left;
    width: 60%;
    li {
      height: 24px;
      line-height: 24px;
      border-left: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:last-child {
        border-bottom: 0;
        height: 23px;
        line-height: 23px;
      }
    }
  }
  .define-part {
    overflow: hidden;
    text-align: center;
    .el-select {
      width: 300px;
      margin-top: 10px;
      input {
        height: 34px;
      }
    }
  }
  .define-title {
    color: #333;
    span {
      color: #999;
    }
  }
  .cross-btn {
    width: 180px;
    margin: 20px auto 30px;
    display: block;
  }
  .add-select-btn {
    display: inline-block;
  }
  .cross-corner {
    height: 48px;
    background-color: #eee;
    border-bottom: 1px solid #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/crossAnalysis.vue